var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconDustCover = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38 38",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1d1d1b",
    d: "M19 38C8.52 38 0 29.48 0 19S8.52 0 19 0s19 8.52 19 19-8.52 19-19 19Zm0-36.16C9.54 1.84 1.84 9.54 1.84 19S9.54 36.16 19 36.16 36.16 28.46 36.16 19 28.46 1.84 19 1.84Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d1d1b",
    d: "M19 24.26c-2.9 0-5.26-2.36-5.26-5.26s2.36-5.26 5.26-5.26 5.26 2.36 5.26 5.26-2.36 5.26-5.26 5.26Zm0-8.68c-1.89 0-3.42 1.53-3.42 3.42s1.53 3.42 3.42 3.42 3.42-1.53 3.42-3.42-1.53-3.42-3.42-3.42Z"
  })));
};
export default SvgIconDustCover;